import { render } from "./SolicitariInlocuire.vue?vue&type=template&id=5b3c6036&scoped=true&ts=true"
import script from "./SolicitariInlocuire.vue?vue&type=script&lang=ts"
export * from "./SolicitariInlocuire.vue?vue&type=script&lang=ts"

import "./SolicitariInlocuire.vue?vue&type=style&index=0&id=5b3c6036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3c6036"]])

export default __exports__